module.exports = __webpack_public_path__ + "img/update-command-bar-shortcut.43434988.gif";